export function throttle(func, wait) {
    var previous = 0;
    return function () {
        let now = Date.now();
        let context = this;
        let args = arguments;
        if (now - previous > wait) {
            func.apply(context, args);
            previous = now;
        }
    }
}

export function getBrowserLanguage() {
    let navigatorLanguage = (navigator.language || navigator.browserLanguage).toLowerCase();
    navigatorLanguage = navigatorLanguage.substr(0, 2);
    let activeLan = ['zh', 'en', 'ja', 'zh_tw'];
    return activeLan.includes(navigatorLanguage) ? navigatorLanguage : 'zh'
}